import { AgentConversationDialog } from "@/components/reporting/agent-conversation-dialog"
import { api } from "@/lib/api"

export function AiConversationDialog({
	sessionId,
	onClose,
}: {
	sessionId: string | null
	onClose: () => void
}) {
	const query = api.analytics.aiSessionConversation.useQuery(
		{ sessionId: sessionId ?? "" },
		{ enabled: sessionId !== null },
	)

	return (
		<AgentConversationDialog
			isOpen={sessionId !== null}
			onClose={onClose}
			conversation={query.data}
			isLoading={query.isLoading}
			heading={query.data?.workspaceName ?? "Conversation"}
			headingImageUrl={query.data?.workspaceLogoUrl ?? null}
		/>
	)
}
